// src/pages/MACCIAHome.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const MACCIAHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Rankings", emoji: "🏆" },    
    { label: "Learning & Development", emoji: "📚" },
    { label: "MSME Productivity", emoji: "⚡" },
    { label: "AgriLink", emoji: "🌱" },     
    { label: "Manufacturing", emoji: "🏭" },
    { label: "SAKSHAM Shakti", emoji: "💖" },           
    { label: "Micro CCM", emoji: "📅" },
    { label: "Jobs & AI", emoji: "🤖" },      
    { label: "Finance & Compliance", emoji: "💳" },
    { label: "PehchaanSetu", emoji: "🌉" },
    { label: "Market & Engagement", emoji: "🛍️" },
    { label: "Owner Self Reflection", emoji: "🪞" },
    { label: "MSME Games", emoji: "🎮" },
    { label: "Exim Lens", emoji: "🧭" }, 
    { label: "Digital Micro Income", emoji: "💰" },
    { label: "SAKSHAM Adoption", emoji: "🧗" },  
    { label: "India@2047", emoji: "🚀" },        
  ];

  const menuButtons1 = [
    // 🏆 Rankings
    { label: "Maharashtra Udyam Ranking", emoji: "🏅", link: "/udyampragatiscore", group: "Rankings" },
    { label: "India Udyam Ranking", emoji: "🏅", link: "/udyampragatiscore", group: "Rankings" },    
    { label: "SAKSHAM Database", emoji: "💾", link: "/msmedb", group: "Rankings" },
    { label: "Maha Winners", emoji: "🏆", link: "/syntramfgdb", group: "Rankings" },
    { label: "India Winners", emoji: "🏆", link: "/syntramfgdb", group: "Rankings" },
    { label: "Mature MSME Scorecard", emoji: "📈", link: "/msme-processscore", group: "Rankings" },

    // 📚 Learning & Development
    { label: "MSME Success Kit", emoji: "🧰", link: "/startupkit", group: "Learning & Development" },
    { label: "MSME Learning", emoji: "🗓️", link: "/msme-bookworld", group: "Learning & Development" },
    { label: "MSME Bookshelf", emoji: "📖", link: "/bookshelf", group: "Learning & Development" },
    { label: "MSME Shorts", emoji: "🗞️", link: "/litenshort", group: "Learning & Development" },
    { label: "MSME Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "Learning & Development" },
    { label: "Podcast", emoji: "️🎙️", link: "/podcast-mylist", group: "Learning & Development" },
    { label: "msmeTube", emoji: "️▶️", link: "/msmetube", group: "Learning & Development" },
    { label: "startupTube", emoji: "⏩", link: "/startuptube", group: "Learning & Development" },
    { label: "India Civic Index", emoji: "🏙️", link: "/Learning & Development" },   
    { label: "LnD", emoji: "🗓️", link: "/lnd", group: "Learning & Development" },

    // 📚 Startup Kit
    { label: "Startup Success Kit", emoji: "🧰", link: "/startupkit", group: "Startup Kit" },

    // ⚡ MSME Productivity
    { label: "TRACK", emoji: "🚦", link: "/msme-track", group: "MSME Productivity" },    
    { label: "MSME Self Assessment", emoji: "🧠", link: "/msme-selfassessment", group: "MSME Productivity" },    
    { label: "Business Digital Card", emoji: "💼", link: "/msme-digitalcard", group: "MSME Productivity" },
    { label: "MSME Year Book", emoji: "📚", link: "/msmeyb-home", group: "MSME Productivity" },
    { label: "DeepThinking Lab", emoji: "🔍", link: "/fivewhys-analysis-home", group: "MSME Productivity" },
    { label: "Business Chronicles", emoji: "📖", link: "/msme-business-chronicles", group: "MSME Productivity" },
    { label: "Business Diary", emoji: "📓", link: "/mydiary-home", group: "MSME Productivity" },
    { label: "Business Journal", emoji: "🗒️", link: "/myjournal-home", group: "MSME Productivity" },
    { label: "Minutes of Meeting", emoji: "✍️", link: "/tasks/add", group: "MSME Productivity" },
    { label: "Goal Board", emoji: "🏁", link: "/msme-goalboard", group: "MSME Productivity" },
    { label: "Process & RACI Board", emoji: "🧩", link: "/msme-processraci", group: "MSME Productivity" },
    { label: "Kanban", emoji: "📊", link: "/msme-kanban", group: "MSME Productivity" },
    { label: "CommuniCapture", emoji: "📢", link: "/communicapture-home", group: "MSME Productivity" },
    { label: "TrackBuddy AI", emoji: "📍", link: "/trackbuddy", group: "MSME Productivity" },
    { label: "LLM Capture", emoji: "🧠🤖", link: "/msme-llmcapture", group: "MSME Productivity" },
    { label: "Auto Payment Reminder", emoji: "⏰💳", link: "/prs", group: "MSME Productivity" },
    { label: "KRA-KPI", emoji: "⏰💳", link: "", group: "MSME Productivity" },
    { label: "SOPHub", emoji: "🔗", link: "/sophub", group: "MSME Productivity" },
    { label: "POHub", emoji: "🔗", link: "/pohub", group: "MSME Productivity" },
    { label: "Consultants", emoji: "🧑‍💼", link: "/think5whys-counsellors", group: "MSME Productivity" },
    { label: "Design Of Experiments", emoji: "🧪", link: "/doe", group: "MSME Productivity" },

    // 🪞 SELF REFLECTION
    { label: "Personal Digital Card", emoji: "📘", link: "/msme-digitalcard", group: "Owner Self Reflection" },
    { label: "Owner's Self Management", emoji: "🙋‍♀️", link: "/msme-self-chronicles", group: "Owner Self Reflection" },
    { label: "Personal Diary", emoji: "📔", link: "/mydiary-home", group: "Owner Self Reflection" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Owner Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/msme-focustimerstart", group: "Owner Self Reflection" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Owner Self Reflection" },
    { label: "My Outreach", emoji: "📣👥", link: "/outreach", group: "Owner Self Reflection" },
    { label: "My Limit", emoji: "️📏", link: "/mylimit", group: "Owner Self Reflection" },
    { label: "Personal AI Counselling", emoji: "🧑‍💼🤖", link: "/aicounselling", group: "Owner Self Reflection" },
    { label: "Owner Productivity Suite", emoji: "🧠⚙️", link: "", group: "Owner Self Reflection" },  

    // 🌱 AgriLink
    { label: "Agri & Rural Economy Home", emoji: "🌱", link: "/agrilink", group: "AgriLink" },   
    { label: "MSME2Farmers", emoji: "🌾🤝", link: "/mykisan", group: "AgriLink" },

    // 🏭 Manufacturing
    { label: "SyntraMfg Home", emoji: "🏭", link: "/syntramfg", group: "Manufacturing" },  

    // 💖 SAKSHAM Shakti
    { label: "SheLearns",  emoji: "📘", link: "/sheearns", group: "SAKSHAM Shakti" },  
    { label: "SheManages", emoji: "📊", link: "/sheearns", group: "SAKSHAM Shakti" },  
    { label: "SheEarns",   emoji: "💰", link: "/sheearns", group: "SAKSHAM Shakti" },  
    { label: "SheWorks",   emoji: "💼", link: "/sheearns", group: "SAKSHAM Shakti" },  
    { label: "SheWins",    emoji: "🏆", link: "/sheearns", group: "SAKSHAM Shakti" },  
    { label: "MahilaMandi",    emoji: "🛒🏡", link: "/sheearns", group: "SAKSHAM Shakti" },  
 
    // 🔄 MSME CCM (Contacts. Communication. Meetings)
    { label: "My Digital Card", emoji: "💼", link: "/msme-digitalcard", group: "Micro CCM" },
    { label: "Client's Digital Card", emoji: "👤", link: "/contact-genious-clientcards", group: "Micro CCM" },
    { label: "My Speaking Card", emoji: "🎙️", link: "/contact-genious-speakingcard", group: "Micro CCM" },
    { label: "Card Visibility Dashboard", emoji: "📊", link: "/contact-genious-cardviewstats", group: "Micro CCM" },
    { label: "Connect / PehchaanSetu", emoji: "🤝", link: "/pehchaansetu", group: "Micro CCM" },
    { label: "Meeting Calendar", emoji: "📅", link: "/calendar-list", group: "Micro CCM" },
    { label: "Visits for Meeting", emoji: "📍", link: "/visits-list", group: "Micro CCM" },
    { label: "Meeting Thoughts", emoji: "💭", link: "/thoughts-list", group: "Micro CCM" },
    { label: "Meeting TODO", emoji: "✅", link: "/todo-list", group: "Micro CCM" },
    { label: "Meeting Tasks", emoji: "🛠️", link: "/tasks-list", group: "Micro CCM" },
    { label: "Travelling for Meetings", emoji: "🚗", link: "/travels-list", group: "Micro CCM" },
    { label: "Meeting Checklist", emoji: "📋", link: "/checklist-list", group: "Micro CCM" },
    { label: "Meeting Record", emoji: "🗂️", link: "/meetings-list", group: "Micro CCM" },
    { label: "Whisper", emoji: "🤫", link: "", group: "Micro CCM" },
    { label: "Meeting Analytics AI", emoji: "🧠📈", link: "", group: "Micro CCM" },

    // 🤖 Jobs & AI
    { label: "Blue Collar Jobs", emoji: "👨‍🌾", link: "/bluehands-home", group: "Jobs & AI" },
    { label: "Skill Development", emoji: "👨‍🌾", link: "/lnd", group: "Jobs & AI" },
    { label: "Digital Boutique", emoji: "🏬", link: "/digiboutique", group: "Jobs & AI" },
    { label: "AI Counselling", emoji: "🤖", link: "/aicounselling-about", group: "Jobs & AI" },
    { label: "Business AI Counselling", emoji: "🧠", link: "/aicounselling", group: "Jobs & AI" },    
    { label: "Offboarded DB", emoji: "📤", link: "/offboarded-home", group: "Jobs & AI" },

    // 💳 Finance & Compliance
    { label: "NPA Solutions", emoji: "⚠️", link: "/msme-npahome", group: "Finance & Compliance" },
    { label: "ValueShare", emoji: "💾", link: "/orderflow-earning-estimator", group: "Finance & Compliance" },
    { label: "Funding & Loans", emoji: "💰", link: "/fundlanes", group: "Finance & Compliance" },
    { label: "Payment Dodger DB", emoji: "🚫💰", link: "/offboarded-home", group: "Finance & Compliance" },

    // 🌉 PehchaanSetu 
    { label: "PehchaanSetu Home", emoji: "🔗", link: "/pehchaansetu", group: "PehchaanSetu" },

    // 🛍️ Market & Engagement
    { label: "MSME Marketplace", emoji: "🏪", link: "/orderflow-home", group: "Market & Engagement" },
    { label: "LensShop", emoji: "🏪", link: "/lensshop", group: "Market & Engagement" },
    { label: "HVAC Marketplace", emoji: "🏪", link: "/airon", group: "Market & Engagement" },
    { label: "Cutlery Marketplace", emoji: "🏪", link: "/crockery", group: "Market & Engagement" },
    { label: "Marketing Campaigns", emoji: "📣", link: "/treach", group: "Market & Engagement" },
    { label: "CSAT", emoji: "💬", link: "/csat", group: "Market & Engagement" },
    { label: "BoloGrahak", emoji: "🙋‍♀️", link: "/bolograhak", group: "Market & Engagement" },
    { label: "Forum", emoji: "🗣️", link: "/povify-home", group: "Market & Engagement" },
    { label: "TwiWrold", emoji: "🌐", link: "/twiworld", group: "Market & Engagement" },
    { label: "MSME MetaVerse", emoji: "🕶️", link: "/msme-metaverse", group: "Market & Engagement" },
    { label: "Innovations", emoji: "🚀", link: "/msme-innovationhub", group: "Market & Engagement" },

    // 🎮 MSME  Games
    { label: "Mind of a CEO Series", emoji: "🧠", link: "/msme-games-strategic", group: "MSME Games" },
    { label: "Operational Intelligence", emoji: "⚙️", link: "/msme-games-operational", group: "MSME Games" },
    { label: "Relaxation + Clarity", emoji: "🎯", link: "/msme-games-edutainment", group: "MSME Games" },
    { label: "Other MSME Games", emoji: "🕹️", link: "/msme-games-other", group: "MSME Games" },

    // 🧗 SAKSHAM Adoption
    { label: "Ladder", emoji: "🪜", link: "/msme-think5whysmaturity", group: "SAKSHAM Adoption" },
    { label: "Stakeholders", emoji: "👨‍💼", link: "/msme-think5whysroles", group: "SAKSHAM Adoption" },
    { label: "SAKSHAM MSME Advisor", emoji: "🤝", link: "/msme-advisors", group: "SAKSHAM Adoption" },
    { label: "Empowering PMMY Enterprises", emoji: "💪", link: "/growsure", group: "SAKSHAM Adoption" },

    // 🧭 EximLens
    { label: "Overview", emoji: "🧭", link: "/eximlens/overview", group: "Exim Lens" },
    { label: "Data Behind the Lens", emoji: "📚", link: "/eximlens/data", group: "Exim Lens" },
    { label: "Market Signals", emoji: "📊", link: "/eximlens/signals", group: "Exim Lens" },
    { label: "Trade Focus Areas", emoji: "🌐", link: "/eximlens/focus", group: "Exim Lens" },
    { label: "Think5Whys Insights", emoji: "🧠", link: "/eximlens/think5whys", group: "Exim Lens" },
    { label: "MSME Action View", emoji: "🎯", link: "/eximlens/action", group: "Exim Lens" },
    { label: "About & Disclaimer", emoji: "ℹ️", link: "/eximlens/about", group: "Exim Lens" },

    // 💰 DIGITAL INCOME
    { label: "Monthly Digital Income", emoji: "💻🌱", link: "/msme-bookworld", group: "Digital Micro Income" },
    { label: "Kharcho Jeeto", emoji: "💰", link: "/kharchojeeto", group: "Digital Micro Income" },
    { label: "Referral Income", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Digital Micro Income" },
    { label: "Resell", emoji: "♻️", link: "/msme-enroll", group: "Digital Micro Income" },
    { label: "Rewarding Ads", emoji: "🎁📢", link: "/visigift-home", group: "Digital Micro Income" },
    { label: "Rewarding Videos", emoji: "🎥", link: "/orderflow-spotbuy", group: "Digital Micro Income" },
    { label: "Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "Digital Micro Income" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold bg-gradient-to-r from-amber-300 to-yellow-100 bg-clip-text text-transparent">
            SAKSHAM MSME <span className="text-white/90">by</span> <span className="text-blue-300">MACCIA</span>
          </div>
          <div className="text-[11px] text-gray-200">A Proposed Collaboration of MACCIA: Maharshtra Chamber of Commerce, Industries And Agriculture and Think5Whys Global DeepTech Solutions</div>
          <div className="text-xs text-yellow-200">Owner Centric. Transparency. Connecting Skill with Productivity. Skilled And Keen, Systematic Hands Achieve More!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      <div className="bg-cyan-800 text-white text-xs lg:text-sm py-2">
        <div className="px-1 flex flex-wrap justify-center gap-2">
          <a href="/msme-whysakshammsme" className="hover:text-yellow-200">💭 About</a>
          <Link to="/litenshort" className="hover:text-yellow-200">🗞️ MSME News</Link>
          <a href="/fundlanes" className="hover:text-yellow-200">💰 Funding</a>
          <a href="/growsure" className="hover:text-yellow-200">💪 PMMY</a>
          <a href="/ledger" className="hover:text-yellow-200">📊 ERP</a>
          <a href="/msme-think5whysfaq" className="hover:text-yellow-200">🤔 FAQ</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>
        </div>
      </div>

      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-[10px] text-xs lg:text-sm font-medium transition bg-transparent hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions, Mumbai.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MACCIAHome;
